<div class="bm--bg-popup">
  <div
    class="confirm-order-popup theme-popUp__confirm-order"
    [ngClass]="{ 'confirm-order-popup--colorSettingsMode': colorSettingsMode }"
  >
    <!-- Header-->
    <div class="confirm-order-popup__header">
      <p class="confirm-order-popup__header-title theme-popUp__confirm-title">
        {{ lg.confirmationOrderPopup.checkout }}
      </p>
      <div class="btv-icon-close theme-popUp__confirm-icon-cancel" (click)="closePopup()"></div>
    </div>

    @if (isLoader) {
      <div style="margin-bottom: 20px">
        <bmcore-loader></bmcore-loader>
      </div>
    }

    <!-- Form -->
    <bmcore-confirm-order-form
      [group]="group"
      [paymentSource]="paymentSource"
      (hideSpinnerEvent)="hideSpinner()"
      [widgetId]="widgetId"
    >
    </bmcore-confirm-order-form>

    <p class="confirm-order-popup__required-text theme-popUp__confirm-requiredField">
      {{ lg.contactsBlock.requiredFieldDescription }}
    </p>

    <!-- License info -->
    <p class="confirm-order-popup__license-term theme-popUp__confirm-description">
      {{ lg.confirmationOrderPopup.agreeLicenseTerm }}
    </p>
    <a class="confirm-order-popup__license-link theme-popUp__confirm-description" routerLink="/user-agreement">
      {{ lg.footer['user-agreement'] }}
    </a>
  </div>
</div>
